module.exports = __webpack_public_path__ + "static/media/VD_Cover.4d809d52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/VD_Cover.jpg
// module id = 351
// module chunks = 0